import React from "react";
import { Pressable, Text, View } from "react-native";

import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

const AVAILABLE_HOME_IDS = new Set([
  "what_is_ai",
  "history",
  "how_it_works",
  "ai_today",
  "impact",
  "ask_ai",
]);

export default function ExhibitHomeScreen({ navigate, copy }) {
  return (
    <View style={{ padding: 28 }}>
      <Text
        style={{
          color: C.accent,
          fontSize: 13,
          fontWeight: "900",
          letterSpacing: 1.2,
        }}
      >
        {copy.homeScreen.eyebrow}
      </Text>

      <Text
        style={{
          color: C.text,
          fontSize: 46,
          lineHeight: 52,
          fontWeight: "900",
          marginTop: 8,
        }}
      >
        {copy.homeScreen.title}
      </Text>

      <Text style={{ color: C.muted, fontSize: 21, marginTop: 8 }}>
        {copy.homeScreen.subtitle}
      </Text>

      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 16,
          marginTop: 28,
        }}
      >
        {copy.homeScreen.cards.map((card) => {
          const available = AVAILABLE_HOME_IDS.has(card.id);

          return (
            <Pressable
              key={card.id}
              onPress={available ? () => navigate(card.id) : undefined}
              disabled={!available}
              accessibilityRole="button"
              style={({ pressed }) => ({
                width: "31.8%",
                minWidth: 290,
                minHeight: 175,
                flexGrow: 1,
                padding: 22,
                borderRadius: 20,
                borderWidth: 1,
                borderColor: available ? C.border : "#1f3448",
                backgroundColor:
                  available && pressed ? C.accentSoft : C.surfaceRaised,
                opacity: available ? 1 : 0.5,
              })}
            >
              <Text style={{ fontSize: 34 }}>{card.icon}</Text>
              <Text
                style={{
                  color: C.text,
                  fontSize: 23,
                  fontWeight: "900",
                  marginTop: 14,
                }}
              >
                {card.title}
              </Text>
              <Text
                style={{
                  color: C.muted,
                  fontSize: 16,
                  lineHeight: 23,
                  marginTop: 7,
                }}
              >
                {card.subtitle}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </View>
  );
}
